import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";

@Component({
    selector: 'customer-master-page',
    templateUrl: './customer-master-page.html',
})
export class CustomerMasterPageComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);

        this.searchOpts = [
            { label: 'None', value: 0 },
            { label: 'Customer Code', value: 1 },
            { label: 'Customer Name', value: 2 }
        ]
    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.onSearch();
    }

    onSearch() {
        let params = new UrlParams();
        params.add('custCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('custName', this.searchType == 2 ? (this.searchValue == null ? '' : this.searchValue) : '');

        this.gridData = this.http.getByManager(`api/CustomerMaster/GetPage?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('custCode', this.searchType == 1 ? this.searchValue : '');
        params.add('custName', this.searchType == 2 ? this.searchValue : '');
        this.waiting = true;
        this.http.download(`api/CustomerMaster/Export?${params.toString()}`, res => {
            let fileNameExport = 'CRM_CustomerMaster.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        this.dlgImport.show('api/CustomerMaster/Import', null, res => {
            this.grid.refresh();
        });
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/CustomerMaster/Remove/${id}`, res => {
                this.grid.refresh();
            });
        });
    }
}
